import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../../ui';
import { Sebastian } from '../../canvas/ui/Sebastian';
import { Flexer, Title } from '../../dashboard/elements/LayoutElements';

const Frame = styled.div`
    padding: 1rem;
    
    ${Title} {
        color: ${Colors.text};
        font-weight: 500;
        font-size: 1.125rem;
    }
`;

export const TutorialAlert = ({ children }: { children: React.ReactNode }) =>
    <Frame>
        <Flexer flex="row" align="start" minHeight="7">
            <Sebastian stance="teach" size="6" />
            <Flexer flex="column" padding="1 1 0 1">
                {children}
            </Flexer>
        </Flexer>
    </Frame>;
